export const userProffesionList = [
  { name: "Individual", value: "Individual" },
  { name: "Business", value: "Business" },
];
